import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api.js';
import Spinner from '../components/Spinner.jsx';
import ProgressBar from '../components/ProgressBar.jsx';
import InviteModal from './InviteModal.jsx';
import NewStudentModal from './NewStudentModal.jsx';

export default function Dashboard() {
  const [students, setStudents] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [error, setError]       = useState(null);
  const [showInvite, setShowInvite]   = useState(false);
  const [showNew, setShowNew]         = useState(false);

  const load = () => {
    setLoading(true);
    api.getStudents()
      .then(setStudents)
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-bold text-gray-900">Schüler</h1>
        <div className="flex gap-2">
          <button onClick={() => setShowInvite(true)} className="btn-secondary text-xs">
            📧 Schüler einladen
          </button>
          <button onClick={() => setShowNew(true)} className="btn-primary text-xs">
            + Schüler anlegen
          </button>
        </div>
      </div>

      {loading && <div className="flex justify-center py-12"><Spinner size="lg" /></div>}
      {error   && <div className="rounded-lg bg-red-50 border border-red-200 p-4 text-sm text-red-700">{error}</div>}

      {/* Schülerliste */}
      {!loading && !error && (
        <div className="space-y-3">
          {students.length === 0 && (
            <div className="card text-center text-gray-500 py-10 text-sm">
              Noch keine Schüler. Lege einen neuen an!
            </div>
          )}
          {students.map((s) => (
            <div key={s.id} className="card">
              <div className="flex items-start justify-between gap-4">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-semibold text-gray-900">{s.kuerzel}</span>
                    <span className="badge bg-blue-50 text-blue-700">Stufe {s.stufe_ziel}</span>
                    {!s.aktiv && <span className="badge bg-gray-100 text-gray-400">inaktiv</span>}
                  </div>
                  <ProgressBar done={s.progress_done} total={s.progress_total} className="mt-2" />
                  <p className="text-xs text-gray-400 mt-1">
                    {s.dives_count} Tauchgang{s.dives_count !== 1 ? 'gänge' : ''} geloggt
                  </p>
                </div>
                <div className="flex flex-col gap-1 shrink-0">
                  <Link
                    to={`/ausbilder/schueler/${s.id}/vordienst`}
                    className="btn-primary text-xs whitespace-nowrap"
                  >
                    🎯 Vor dem Dienst
                  </Link>
                  <Link
                    to={`/ausbilder/schueler/${s.id}`}
                    className="btn-secondary text-xs whitespace-nowrap"
                  >
                    📋 Checkliste
                  </Link>
                  <Link
                    to={`/ausbilder/schueler/${s.id}/tauchgaenge`}
                    className="btn-ghost text-xs whitespace-nowrap"
                  >
                    🤿 Tauchgänge
                  </Link>
                  <Link
                    to={`/ausbilder/schueler/${s.id}/quiz-stats`}
                    className="btn-ghost text-xs whitespace-nowrap"
                  >
                    📊 Quiz-Auswertung
                  </Link>
                  <Link
                    to={`/ausbilder/schueler/${s.id}/nachweis`}
                    className="btn-ghost text-xs whitespace-nowrap"
                  >
                    🖨 Nachweis
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showInvite && <InviteModal students={students} onClose={() => setShowInvite(false)} />}
      {showNew    && <NewStudentModal onClose={() => { setShowNew(false); load(); }} />}
    </div>
  );
}
